/**
 * @generated SignedSource<<09bf1c90918cbe4a2ecc1e84cc75be83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ServicesWithCredits = "AI_STUDIO" | "AI_STUDIO_3D_MODEL_GENERATOR" | "AI_STUDIO_AD_GENERATOR" | "AI_STUDIO_MAGIC_SWAP" | "AI_STUDIO_MULTI_IMAGE_FUSION" | "AI_STUDIO_PRODUCT_STAGING" | "AI_STUDIO_UPSCALER" | "AI_STUDIO_VIDEO_GENERATOR" | "AI_STUDIO_VTO" | "GENERATIVE_AI" | "GENERATIVE_AI_DESIGN" | "GENERATIVE_AI_IMAGE_GENERATOR" | "GENERATIVE_AI_PRODUCT_STAGING" | "GENERATIVE_AI_VTO" | "TEST_ORDERS" | "VECTORIZE";
export type useGenerationPreflightTrialStatusQuery$variables = {
  serviceName: ServicesWithCredits;
};
export type useGenerationPreflightTrialStatusQuery$data = {
  readonly serviceCredit: {
    readonly hasSellerPurchasedCredits: boolean;
    readonly trialCreditsUsed: boolean;
  } | null;
};
export type useGenerationPreflightTrialStatusQuery = {
  response: useGenerationPreflightTrialStatusQuery$data;
  variables: useGenerationPreflightTrialStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "serviceName",
    "variableName": "serviceName"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "trialCreditsUsed",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasSellerPurchasedCredits",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useGenerationPreflightTrialStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceCredit",
        "kind": "LinkedField",
        "name": "serviceCredit",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGenerationPreflightTrialStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ServiceCredit",
        "kind": "LinkedField",
        "name": "serviceCredit",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0b58a47661f5ec591f37bd0eb110d4de",
    "id": null,
    "metadata": {},
    "name": "useGenerationPreflightTrialStatusQuery",
    "operationKind": "query",
    "text": "query useGenerationPreflightTrialStatusQuery(\n  $serviceName: ServicesWithCredits!\n) {\n  serviceCredit(serviceName: $serviceName) {\n    trialCreditsUsed\n    hasSellerPurchasedCredits\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e591f0ca226decff8cd181ff8658fed4";

export default node;
